// Boost — panggilan ke callable `boost` (functions/boost.js). PLAN_BOOST.md §🔄 [2026-11-04].
// Semua data Boost duduk di server; halaman TIDAK membaca/menulis Firestore `boost_*` terus.
// Pengecualian tunggal: suis `config/boost.open` (useBoostBuka.js) — menu + route pelanggan.
//
// ⚠️ KEMBAR: senarai JENIS di bawah = JENIS_PROGRAM dalam functions/boostTeras.js.
// ⚠️ KEMBAR: kod ralat (`e.details.kod`) datang dari functions/boost.js → kamus boost.err.* (en/ms).
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export const JENIS = {
    tiktok_tap: { label: 'TikTok TAP', platform: 'tiktok', bind: false },
    shopee_bind: { label: 'Shopee Bind', platform: 'shopee', bind: true },
    tiktok_bind: { label: 'TikTok Bind', platform: 'tiktok', bind: true },
};
export const SUSUNAN_JENIS = ['tiktok_tap', 'shopee_bind', 'tiktok_bind'];

export async function panggilBoost(aksi, data = {}, { timeout = 60000 } = {}) {
    const call = httpsCallable(functions, 'boost', { timeout });
    const { data: hasil } = await call({ aksi, ...data });
    return hasil;
}

/** Kod ralat server (atau null). */
export const kodRalat = (e) => e?.details?.kod || null;

/**
 * Mesej ralat untuk PELANGGAN: kamus ikut kod bila ada, kalau tidak mesej server
 * (English). `t` = fungsi kamus; `ganti` = pemboleh ubah ayat (cth { mcn }).
 */
export function mesejRalatPelanggan(e, t, ganti = {}) {
    const kod = kodRalat(e);
    if (kod) {
        const kunci = `boost.err.${kod}`;
        const teks = t(kunci, ganti);
        if (teks && teks !== kunci) return teks;
    }
    if (e?.code === 'functions/not-found' || /not.?found/i.test(String(e?.code || ''))) return t('boost.err.server');
    return e?.message || t('boost.err.server');
}

/** Mesej ralat untuk partner/admin (English — UI admin). */
export const mesejRalat = (e) => e?.message || 'Something went wrong. Try again.';

/** "4 Nov 2026, 9:05 pm" — waktu tempatan browser. */
export function tarikhPendek(ms) {
    if (!ms) return '';
    return new Date(ms).toLocaleString('en-MY', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

function csvSel(v) {
    const s = String(v ?? '');
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
/** Muat turun CSV (BOM supaya Excel baca UTF-8). */
export function muatTurunCsv(namaFail, tajuk, baris) {
    const csv = [tajuk, ...baris].map((r) => r.map(csvSel).join(',')).join('\r\n');
    const url = URL.createObjectURL(new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = namaFail;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Baris CSV permohonan — sama untuk page partner dan admin. */
export const TAJUK_CSV = ['Date', 'Program', 'Status', 'Full name', 'Email', 'WhatsApp', 'TikTok username 1', 'TikTok username 2', 'Shopee username', 'Sheet'];
export const barisCsv = (m) => [
    m.dicipta ? new Date(m.dicipta).toISOString() : '', JENIS[m.jenis]?.label || m.jenis, m.status,
    m.profil?.nama, m.email, m.profil?.wa, m.profil?.tiktok1, m.profil?.tiktok2, m.profil?.shopee, m.sheet?.status || '',
];

export const LABEL_STATUS = { lulus: 'Approved', menunggu: 'Pending', ditolak: 'Rejected' };
export const TONE_STATUS = { lulus: 'ok', menunggu: 'warn', ditolak: 'stop' };
export const LABEL_SHEET = { ok: 'In sheet', gagal: 'Failed', mati: 'Not sent', menunggu: 'Sending' };
export const TONE_SHEET = { ok: 'ok', gagal: 'stop', mati: 'neutral', menunggu: 'warn' };
